import { FC } from 'react';
import { IonButton, IonSpinner } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { AICallDetailCard } from './AICallDetailCard';
import { IAICallDetail } from './AILogsClient';

const useStyles = createUseStyles({
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginBottom: 12
    },
    title: {
        fontWeight: 600,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    error: {
        color: 'var(--ion-color-danger)',
        margin: '12px 0'
    }
});

// Chronological cards for the calls behind one conversation (or a single ungrouped call).
// Each round re-sends the whole turn under zero data retention, so the LAST card's input
// items contain the complete turn including every tool call and result.
export const AIConversationView: FC<{ title: string; calls: IAICallDetail[]; isLoading?: boolean; error?: string; onBack: () => void }> = ({ title, calls, isLoading, error, onBack }) => {
    const classes = useStyles();
    return (
        <div>
            <div className={classes.header}>
                <IonButton size="small" fill="outline" onClick={onBack} data-id="ai-logs-back">Back</IonButton>
                <div className={classes.title}>{title}</div>
            </div>
            {error && <div className={classes.error}>{error}</div>}
            {isLoading && <IonSpinner />}
            {calls.map(call => <AICallDetailCard key={call.callId} call={call} />)}
        </div>
    );
};
